export default __webpack_public_path__ + "static/logo-13-1955cb1cda80b48a4d7d45af64737199.jpeg";